import ScreenSize, { SerializedScreenSize } from 'lib/ScreenSize';
import * as GoogleTag from '.';

export interface AdInfo {
  dimensions: GoogleTag.Dimension[];
  elementId: string;
  targeting: GoogleTag.Targeting | Record<string, string>;
  screenSizes?: SerializedScreenSize[] | undefined;
}

let currentTargeting: GoogleTag.Targeting | undefined;
const slotQueue: AdInfo[] = [];

function manageSlot(adInfo: AdInfo): void {
  console.log('[ADS][ADMANAGER] manageSlot', adInfo.screenSizes, currentTargeting);
  const screenSizes = (adInfo.screenSizes || []).map((ss) => {
    return new ScreenSize(ss);
  });

  if (screenSizes.length > 0 && !GoogleTag.isInDeviceScreen(screenSizes)) {
    console.log('[ADS][ADMANAGER] manageSlot - screen size not matched', adInfo);
    return;
  }

  GoogleTag.defineSlot({
    ...adInfo,
    targeting: adInfo.targeting as Record<string, string>,
    adUnitPath: currentTargeting?.adUnit || '',
  });
  GoogleTag.display(adInfo.elementId);
}

function processSlotQueue(): void {
  console.log('[ADS][ADMANAGER] processSlots', JSON.stringify(slotQueue), currentTargeting?.adUnit);
  while (slotQueue.length > 0) {
    const adSlotInfo = slotQueue.shift()!;
    manageSlot(adSlotInfo);
  }
}

export function createAd(adInfo: AdInfo): void {
  if (currentTargeting) {
    manageSlot(adInfo);
  } else {
    slotQueue.push(adInfo);
  }
}

export function reloadAd(adInfo: AdInfo): void {
  console.log('[ADS][ADMANAGER] reloadAd', adInfo.elementId);
  GoogleTag.destroySlot(adInfo.elementId);
  createAd(adInfo);
}

export function initializeGoogleAds(): void {
  console.log('[ADS][ADMANAGER] initializeGoogleAds');
  GoogleTag.restrictDataProcessing();
}

export function setAdTargeting(targeting: GoogleTag.Targeting): void {
  console.log('[ADS][ADMANAGER] set page targeting', JSON.stringify(targeting));
  GoogleTag.clearTargeting();
  GoogleTag.setPageTargeting(targeting);
  GoogleTag.enableService();
  currentTargeting = targeting;
  processSlotQueue();
}

export function clearAdTargeting(): void {
  console.log('[ADS][ADMANAGER] clear targeting', currentTargeting?.adUnit);
  GoogleTag.clearTargeting();
  currentTargeting = undefined;
  slotQueue.length = 0;
}

export function destroyAd(elementId: string): void {
  console.log('[ADS][ADMANAGER] destroyAd', elementId);
  GoogleTag.destroySlot(elementId);
}

export function getAdSetup(): boolean {
  return true;
}
